import Box from '@mui/material/Box'
import { Close } from '@mui/icons-material'
import { Avatar, IconButton, Salutation } from '@fullscreendigital/carrefour-dex-fe'
import s from './SidebarHeader.scss'
import { getUserName, getUserAvatarString } from 'utils/authService'

const SidebarHeader = ({ handleCloseMenu, storeName, regionName }) => {
  const userInfo = getUserName()
  const avatarString = getUserAvatarString()

  return (
    <Box className={s.menuHeaderContainer}>
      <div style={{ margin: '0 12px' }}>
        <div className={s.userInfoContainer}>
          <div className={s.userAvatarContainer}>
            <Avatar
              alt={userInfo}
              value={avatarString}
              style={{ borderRadius: '8px', width: '56px', height: '56px' }}
            />
          </div>
          <Salutation name={userInfo} onlyName />
        </div>
        {storeName && <div className={s.storeInfoContainer}>Magazin {storeName}</div>}
        {regionName && <div className={s.storeInfoContainer}>Regiune {regionName}</div>}
      </div>

      <IconButton className={s.logo} onClick={handleCloseMenu}>
        <Close />
      </IconButton>
    </Box>
  )
}

export default SidebarHeader
